
import { IQnAReplyItem } from '@ninjacart/nc-nk-core';
import { LikeRegular, LikeSolidRegular, Paragraph, XStack, YStack } from '@ninjacart/nc-nk-ui';
import { MessageCircle } from '@tamagui/lucide-icons';
import { t } from 'i18next';
import { Pressable } from 'react-native';
export function QnaLikeComment({
  reply,
  onAnswerLike,
  likeCount,
  commentCount,
  toggleExpansion,
  isLiked,
  isExpert,
  index
}: {
  reply: IQnAReplyItem;
  onAnswerLike: Function;
  likeCount: number;
  commentCount: number;
  toggleExpansion: Function;
  isLiked: boolean | number | undefined;
  isExpert: boolean;
  index: number | string;
}) {
  return (
    <YStack>
      <XStack
        marginTop={10}
        justifyContent="space-between"
        paddingHorizontal={isExpert ? 5 : 40}
        marginLeft={isExpert ? 0 : 30}
      >
        <XStack onPress={() => onAnswerLike(reply)} alignItems="center"
       testID={`kisan_tId_answerLike_${index}`}
          >
          {!isLiked ? (
            <LikeRegular color={'$color'} size={24} />
          ) : (
            <LikeSolidRegular color={'$primary'} size={24} />
          )}
          <Paragraph color={'$color'} fontSize={14} fontWeight={'500'} paddingLeft={5}>
            {t('page.like')} ({likeCount})
          </Paragraph>
        </XStack>

        <Pressable  onPress={() => toggleExpansion(reply?.id)}
          testID={`kisan_tId_answerComment_${index}`}
          >
        <XStack alignItems="center">
          <MessageCircle color={'$color'} size={24} />
          <Paragraph color={'$color'} fontSize={14} fontWeight={'500'} paddingLeft={5}>
            {t('page.comment')} ({commentCount ?? 0})
          </Paragraph>
        </XStack>
        </Pressable>
      </XStack>
    </YStack>
  );
}
